import "core-js/stable"
import "regenerator-runtime/runtime"
import $ from 'jquery'
window["jQuery"] = $
import moment from 'moment'
import validate from 'validate.js'
import 'formdata-polyfill'

(function() {
  
  validate.options = {
    fullMessages: false
  }
  validate.extend(validate.validators.datetime, {
    parse: function(value, options) {
      return +moment.utc(value);
    },
    format: function(value, options) {
      var format = options.dateOnly ? "YYYY-MM-DD" : "YYYY-MM-DD hh:mm:ss";
      return moment.utc(value).format(format);
    }
  });

  var constraints = {
    memid: {
      presence: {
        message: "Please enter a valid Member ID Number"
      },
      format: { 
        pattern: /^\d{9}-\d{2}$/,
        message: function(value, attribute, validatorOptions, attributes, globalOptions) {
          return validate.format("^%{num} is not a valid Member ID Number", {
            num: value
          });
        }
      },
      length: function(value, attributes, attributeName, options, constraints) {
          return {is: 12};
      }
    },
    dob: {
      presence: {
        message: "Please enter a valid birthdate"
      },
      datetime: {
        dateOnly: true,
        message: "^Please enter a valid birthdate."
      }
    }
  };

  var form = document.querySelector('form.eligibility-form');
  if(form !== null) {
    form.addEventListener("submit", function(ev) {
      ev.preventDefault();
      handleFormSubmit(form);
    });
  }

  function handleFormSubmit(form, input) {
    // Hide tables
    document.querySelector('.eligibility-table').classList.add("hidden");
    document.querySelector('h2.history-header').classList.add("hidden");
    document.querySelector('.eligibility-history-table').classList.add("hidden");
    document.querySelector('.eligibility-msg-err').classList.add("hidden");

    // validate the form against the constraints
    var fields = form.querySelectorAll("input[name], select[name], textarea[name]"), i;
    
    var errors = validate(form, constraints);
    showErrors(form, errors || {});
    if (!errors) {
      // Process form post
      var url = "https://app.uhahealth.com/CheckEligiblity.php";
      var formData = new FormData(form);
      formData.set('dob', moment( formData.get('dob') ).format( 'MM-DD-YYYY' ) );
      var xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.onreadystatechange = function() {
          if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
              showSuccess(form, JSON.parse(xhr.responseText));
          } else if(this.status !== 200) {
              console.log('Error...');
          }
      }
      xhr.send(formData);	
    }
  }

  function showErrors(form, errors) {
    var fields = form.querySelectorAll("input[name], select[name], textarea[name]"), i;
    for (i = 0; i < fields.length; ++i) {
      showErrorsForInput(fields[i], errors && errors[fields[i].name]);
    }
  }

  function showErrorsForInput(input, errors) {
    var formGroup = closestParent(input.parentNode, "frow");
    var messages = formGroup.querySelector(".messages");
    resetFormGroup(formGroup);
    if (errors) {
      formGroup.classList.add("has-error");
      for (var i = 0; i < errors.length; ++i) {
        addError(messages, errors[i]);
      }
    } else {
      formGroup.classList.add("has-success");
    }
  }

  // Recusively finds the closest parent that has the specified class
  function closestParent(child, className) {
    if (!child || child == document) {
      return null;
    }
    if (child.classList.contains(className)) {
      return child;
    } else {
      return closestParent(child.parentNode, className);
    }
  }

  function resetFormGroup(formGroup) {
    formGroup.classList.remove("has-error");
    formGroup.classList.remove("has-success");
    var messages = formGroup.querySelectorAll(".help-block.error"), i;
    for (i = 0; i < messages.length; ++i) {
      messages[i].parentNode.removeChild(messages[i]);
    }
  }

  function addError(messages, error) {
    var block = document.createElement("p");
    block.classList.add("help-block");
    block.classList.add("error");
    block.innerText = error;
    messages.appendChild(block);
  }

  function tostr(s) {
    return typeof s == 'string' ? s : '';
  }
  function member_row_simple(label, copy) {
    return '<tr><th>'+tostr(label)+'</th><td><b>'+tostr(copy)+'</b></td></tr>'; 
  }
  function member_row_template(type, plan, link, linkdes, copay) {
    return '<tr><th>'+tostr(type)+'</th><td><b>'+tostr(plan)+'</b> ' + ( typeof linkdes == 'string' && linkdes !== '' ? '(<a href="'+tostr(link)+'" target="_blank">'+tostr(linkdes)+'</a>)' : '')+(copay !== '' && copay !== undefined ? '<br>'+tostr(copay) : '')+'</td></tr>'; 
  }

  function history_row_template(coverage, effective, term, medical, drug, vision, dental) {
    return '<tr><td>'+tostr(coverage)+'</td><td>'+tostr(effective)+'</td><td>'+tostr(term)+'</td><td>'+tostr(medical)+'</td><td>'+tostr(drug)+'</td><td>'+tostr(vision)+'</td><td>'+tostr(dental)+'</td></tr>';
  }

  function showSuccess(form, res) {

    if(res["EligibilityRecords"]["MsgMemberNotFound"] == "Member Not Found") {
      document.querySelector('.eligibility-msg-err').classList.remove("hidden");
    } else {
      var rows = "";
      var member_status = res["EligibilityRecords"]["FirstEligibilityRecord"]["MsgMemberEligibleOrTermed"];
      var table_label = "Member not found";
      if(member_status == 'MEMBER ELIGIBLE') {
        table_label = "Member Eligible";
      } else if (member_status == 'MEMBER TERMED') {
        table_label = "Member Termed";
      }
      
      // Member eligibility table
      document.querySelector('.eligibility-table thead tr th').innerHTML = table_label;
      var record  = res["EligibilityRecords"]["FirstEligibilityRecord"];
      rows       += member_row_simple("Member name", record["MemberName"]);
      rows       += member_row_simple("Coverage", record["Coverage"]);
      rows       += member_row_simple("Medical plan effective date", record["EffectiveDate"]);
      rows       += member_row_simple("Term date", record["TermDate"]);
      var plan    = record["MedicalPlan"];
      var link    = record["MedicalPlanGuideURL"];
      var linkdes = record["MedicalPlanGuideDescription"];
      var copay   = record["MedicalPlanCopay"];
      
      rows += member_row_template('Medical plan', plan, link, linkdes, copay);
      
      plan    = record["DrugPlan"];
      link    = record["DrugPlanGuideURL"];
      linkdes = record["DrugPlanGuideDescription"];
      copay   = record["DrugPlanCopay"];
      
      rows += member_row_template('Drug plan', plan, link, linkdes, copay);
      
      plan    = record["VisionPlan"];
      link    = record["VisionPlanGuideURL"];
      linkdes = record["VisionPlanGuideDescription"];
      copay   = record["VisionPlanCopay"];
      
      rows += member_row_template('Vision plan', plan, link, linkdes, copay);
        
      plan    = record["DentalPlan"];
      link    = record["DentalPlanGuideURL"];
      linkdes = record["DentalPlanGuideDescription"];
      copay   = record["DentalPlanCopay"];
      
      rows += member_row_template('Dental plan', plan, link, linkdes, copay);
      document.querySelector('.eligibility-table tbody').innerHTML = rows;
      document.querySelector('.eligibility-table').classList.remove("hidden");

      // History table
      rows = '';
      var hisrec  = res["EligibilityRecords"]["HistoryRecord"];
      if(hisrec !== undefined) {
          var history = Array.isArray(hisrec) ? hisrec : [ hisrec ];
          for (var i = 0; i < history.length; ++i) {
              rows += history_row_template( history[i]['Coverage'], history[i]['EffectiveDate'], history[i]['TermDate'], history[i]['MedicalPlan'], history[i]['DrugPlan'], history[i]['VisionPlan'], history[i]['DentalPlan']);
          }
          document.querySelector('.eligibility-history-table tbody').innerHTML = rows;
          document.querySelector('h2.history-header').classList.remove("hidden");
          document.querySelector('.eligibility-history-table').classList.remove("hidden");
      }
    }
  }
})();
